import React from 'react';
import { FeedbackCategory } from 'nekst-api';
import { Dropdown, Option } from 'ui-builder';

const CATEGORY_OPTIONS: Option<string>[] = [
  { value: '', label: 'Select category (optional)' },
  { value: 'wrong_answer' satisfies FeedbackCategory, label: 'Wrong answer' },
  { value: 'irrelevant_response' satisfies FeedbackCategory, label: 'Irrelevant response' },
  { value: 'missing_information' satisfies FeedbackCategory, label: 'Missing information' },
  { value: 'other' satisfies FeedbackCategory, label: 'Other' },
];

export default function FeedbackCategoryDropdown() {
  return (
    <Dropdown<string>
      source="category"
      label="Category (optional)"
      hideLabel
      options={CATEGORY_OPTIONS}
    />
  );
}
